import { Component, Input, OnInit } from "@angular/core";
import { ProFunnelModel } from "../../../model/builk/profunnel/profunnel.model";

@Component({
    template: `{{ proFunnel.companyState | province | async }}`
})
export class ProvinceEntryComponent implements OnInit {
    @Input() rowData: ProFunnelModel;
    proFunnel: ProFunnelModel;

    ngOnInit(): void {
        this.proFunnel = this.rowData;
    }
}
